import { render } from "./LanguageComponent.vue?vue&type=template&id=45c48e58"
import script from "./LanguageComponent.vue?vue&type=script&lang=js"
export * from "./LanguageComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__